import React from 'react';
import { Create } from 'react-admin';
import PageForm from './PageForm';

const PageCreate = () => (
  <Create>
    <PageForm />
  </Create>
);

export default PageCreate;
